import React from "react";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Stack from "react-bootstrap/Stack";

export default function Error({ title, description, onClose }) {
  const handleClose = () => onClose();

  return (
    <Modal.Body className="modal--lg">
      <Stack
        gap={4}
        className="text-center img--round-before img--round-before-lg background-icon-xxl background-icon-danger background-icon-info"
      >
        <h4 className="modal-body-heading-title mb-0">{title}</h4>
        {description && <p>{description}</p>}
      </Stack>
      <Stack className="btn-group-flex">
        <Button size="lg" onClick={handleClose}>
          Close
        </Button>
      </Stack>
    </Modal.Body>
  );
}
